import eventEmitter from 'utilities/event-emitter';
import StorageService from './storage-service';

const AuthService = {
  login: async (idToken) => {
    const { token, refreshToken, tokenExpires } = idToken;
    const expirationDate = new Date(new Date().getTime() + tokenExpires * 1000); // Convert to milliseconds
    StorageService.setItem('authToken', token);
    StorageService.setItem('refreshToken', refreshToken);
    StorageService.setItem('tokenExpiry', expirationDate.toISOString());

    eventEmitter.emit('authenticationChange', true);
  },

  logout: () => {
    StorageService.removeItem('authToken');
    StorageService.removeItem('refreshToken');
    StorageService.removeItem('tokenExpiry');
    
    eventEmitter.emit('authenticationChange', false);
    eventEmitter.emit('botSelected', { clear: true, forced: true });
  },

  isAuthenticated: () => {
    const authToken = StorageService.getItem('authToken');
    const tokenExpiry = new Date(StorageService.getItem('tokenExpiry'));
    return authToken !== null && tokenExpiry > new Date();
  },

  refreshToken: async () => {
    const refreshToken = StorageService.getItem('refreshToken');

    if (!refreshToken) {
      return false;
    }

    try {
      const response = await fetch(process.env.REACT_APP_BASE_URL + 'auth/refresh', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${refreshToken}`,
        },
        body: JSON.stringify({ refreshToken }),
      });

      if (response.ok) {
        const data = await response.json();
        const { token, tokenExpires } = data;
        const expirationDate = new Date(new Date().getTime() + tokenExpires * 1000); // Convert to milliseconds
        StorageService.setItem('authToken', token);
        StorageService.setItem('tokenExpiry', expirationDate.toISOString());
        eventEmitter.emit('authenticationChange', true);
        return token;
      } else {
        AuthService.logout(); // Clear tokens if refresh fails
        return false;
      }
    } catch (error) {
      console.error('Error refreshing token:', error);
      AuthService.logout(); // Clear tokens if refresh fails
      return false;
    }
  },
};

export default AuthService;
